import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import SpogLink from 'router-with/ui/SpogLinkRoute';
import Icon from 'components/ui/element/Icon';

import 'style/components/ui/form/spog-button.scss';

/** Component to draw a button with text and icon */
export class SpogButton extends Component {
    static propTypes = {
        href:                PropTypes.string, //the target of button
        text:                PropTypes.oneOfType([PropTypes.object, PropTypes.string]), //the key of locale text
        className:           PropTypes.string, //a class to be added
        icon:                PropTypes.string, //the name of the icon to show
        bsStyle:             PropTypes.string, //the text to be added to 'btn-' so defining the background class
        disabled:            PropTypes.bool, //if the button is disabled
        iconRight:           PropTypes.bool, // True when the icon should render at right
        iconLg:              PropTypes.bool, // True if the icon button should be large
        iconExtraClassNames: PropTypes.string, // Extra class for icon
        notFormat:           PropTypes.bool, // True when the text should't be formatted
        externalLink:        PropTypes.bool, //if the href should be an external endpoint
        noBorders:           PropTypes.bool, // By default false. True if the button doesnt need borders
        onClick:             PropTypes.func, // The function when you click on the button.
        iconColor:           PropTypes.string, // Icon color
        tooltip:             PropTypes.string, // The tooltip for the button
        width:               PropTypes.string // string with an specificy width (you must change CSS)

    };

    static defaultProps = {
        className:           '',
        width:               '',
        bsStyle:             'default',
        iconExtraClassNames: '',
        iconRight:           false,
        notFormat:           false,
        noBorders:           false
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleClick = this.handleClick.bind(this);
    }

    /**
     * Preventing default
     * @param e
     */
    handleClick(e) {
        e && e.preventDefault && e.preventDefault();
        const {onClick} = this.props;

        onClick && onClick(e);
    }

    renderIcon() {
        const { icon, iconLg, iconColor, iconExtraClassNames } = this.props;

        return icon ?
            <Icon
                key="icon"
                name={icon}
                className={`spog-icon ${iconExtraClassNames}`}
                lg={iconLg}
                color={iconColor}
            /> :
            null;
    }

    renderText() {
        const { text, notFormat } = this.props;

        return text ?
            notFormat ? <span key="text">{text}</span> : <FormattedMessage id={text} key="text" /> :
            null;
    }

    renderContent() {
        const { iconRight } = this.props;

        return iconRight ?
            [this.renderText(), this.renderIcon()] :
            [this.renderIcon(), this.renderText()];
    }

    //  title="I'm a tooltip"

    render() {
        const { href, bsStyle, className, disabled, externalLink, noBorders, width, text, tooltip} = this.props,
            _getClassName = () => `spog-button ${className} ${noBorders ? 'no-border' : ''} ${width} btn btn-${bsStyle}`;

        let formatter;

        if (this.props.intl) {
            const {intl : {formatMessage}} = this.props;

            formatter = formatMessage;
        }

        let _tooltip;

        if (text) {
            _tooltip = formatter ? formatter({id: text}) : undefined;
        }

        return (
            <span title={tooltip || _tooltip}>
                <SpogLink external={externalLink} disabled={disabled} to={href || '#'} className={_getClassName(bsStyle)} onClick={this.handleClick}>
                    {this.renderContent()}
                </SpogLink>
            </span>
        );
    }
}

export default injectIntl(SpogButton);



// WEBPACK FOOTER //
// ./src/components/ui/form/SpogButton.jsx